import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { isArray, get } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { EMPTY_INFO_MARK } from '../../constants/consts';

const useStyles = makeStyles(() => ({
  root: {
    fontWeight: props => props.fontWeight,
  },
  list: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  qualification: {
    fontWeight: 'normal',
    fontStyle: 'italic',
    fontSize: '13px',
  },
}));

const ListText = ({ className, list, display, fontWeight, fieldToDisplay, emptyMark, listSeparator }) => {
  const classes = useStyles({ fontWeight });
  const listToDisplay = isArray(list) ? list : [list];

  if (listToDisplay?.length === 0) {
    return <span className={cn(classes.root, className)}>{EMPTY_INFO_MARK}</span>;
  }

  return (
    <>
      {display === 'list' && (
        <div className={cn(classes.root, classes.list, className)}>
          {listToDisplay
            .map(item => (typeof item === 'object' ? get(item, fieldToDisplay) || emptyMark : item || emptyMark))
            .join(listSeparator)}
        </div>
      )}
      {display === 'column' && (
        <div className={cn(classes.root, className)}>
          {listToDisplay.map(item => (
            <div key={get(item, fieldToDisplay) || uuidv4()}>{get(item, fieldToDisplay) || emptyMark}</div>
          ))}
        </div>
      )}
    </>
  );
};

ListText.propTypes = {
  className: PropTypes.string,
  list: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  display: PropTypes.oneOf(['column', 'list']),
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fieldToDisplay: PropTypes.string,
  emptyMark: PropTypes.string,
  listSeparator: PropTypes.string,
};

ListText.defaultProps = {
  list: [],
  display: 'list',
  fontWeight: 'reqular',
  fieldToDisplay: 'name',
  emptyMark: EMPTY_INFO_MARK,
  listSeparator: ' / ',
};

export default memo(ListText);
